/**
 * Filter system configuration - filterable fields, operators, and mock data.
 * This file will be replaced by API responses once the backend is ready.
 */

// --------------- Operators ---------------
export const OPERATOR_LABELS = {
  eq: 'Uguale a',
  neq: 'Diverso da',
  like: 'Contiene',
  gt: 'Maggiore di',
  gte: 'Maggiore o uguale a',
  lt: 'Minore di',
  lte: 'Minore o uguale a',
  in: 'Uno tra',
  not_in: 'Nessuno tra',
  between: 'Tra',
  is_null: 'Vuoto',
  is_not_null: 'Non vuoto',
  not_exists: 'Non possiede',
};

// --------------- Preview Table Columns ---------------
export const PREVIEW_COLUMNS = [
  { field: 'name', label: 'Nome' },
  { field: 'surname', label: 'Cognome' },
  { field: 'email', label: 'Email' },
  { field: 'phone', label: 'Telefono' },
  { field: 'role_id', label: 'Ruolo' },
  { field: 'user_online', label: 'Utente Online' },
  { field: 'gender', label: 'Genere' },
  { field: 'fiscal_code', label: 'Codice Fiscale' },
  { field: 'entity_name', label: 'Entità Master' },
  { field: 'federation_name', label: 'Federazione' },
  { field: 'birth_date', label: 'Data di Nascita' },
  { field: 'status', label: 'Stato' },
  { field: 'verified', label: 'Verificato' },
  { field: 'user_status', label: 'Bloccato' },
  { field: 'allow_news', label: 'Newsletter' },
  { field: 'created_at', label: 'Data di Creazione' },
  { field: 'pipeline_stage', label: 'Fase' },
  { field: 'user_positions_position_id', label: 'Carica' },
  { field: 'campaign_user_cards_payment_type', label: 'Tipo di Pagamento' },
  { field: 'campaign_user_cards_campaign_id', label: 'Campagna di Tesseramento' },
  { field: 'campaign_user_cards_payment_status', label: 'Stato di Pagamento' },
  { field: 'user_authorizations_object_id', label: 'Autorizzazione' },
  { field: 'user_authorizations_authorization_type_id', label: 'Tipo Autorizzazione' },
  { field: 'user_positions_entity_id', label: 'Entità Carica' },
  { field: 'user_positions_entity_entity_type_id', label: 'Tipo Entità Carica' },
];

// --------------- Mock Data ---------------

// Mock saved filters for the list page
export const MOCK_FILTERS = [
  {
    id: '1',
    name: 'Utenti attivi verificati',
    target_entity: 'users',
    logic_operator: 'and',
    conditions_count: 2,
    total_results: 342,
    created_at: '2025-12-01',
    user: { name: 'Admin' },
    entity: 'Federazione Test ',
  },
  {
    id: '2',
    name: 'Utenti con email Gmail',
    target_entity: 'users',
    logic_operator: 'and',
    conditions_count: 1,
    total_results: 87,
    created_at: '2025-12-10',
    user: { name: 'Admin' },
    entity: 'Circolo Test',
  },
];

// Mock preview results
const MOCK_USERS = [
  {
    name: 'Mario',
    surname: 'Rossi',
    email: 'mario.rossi@gmail.com',
    fiscal_code: 'RSSMRA80A01H501Z',
    status: 'active',
  },
  {
    name: 'Giulia',
    surname: 'Bianchi',
    email: 'giulia.bianchi@email.it',
    fiscal_code: 'BNCGLI85B42F205X',
    status: 'active',
  },
  { name: 'Luca', surname: 'Verdi', email: 'luca.verdi@gmail.com', fiscal_code: 'VRDLCU90C03L219Y', status: 'active' },
  {
    name: 'Anna',
    surname: 'Ferrari',
    email: 'anna.ferrari@pec.it',
    fiscal_code: 'FRRNNA75D44D612W',
    status: 'inactive',
  },
  {
    name: 'Marco',
    surname: 'Esposito',
    email: 'marco.esposito@gmail.com',
    fiscal_code: 'SPSMRC82E05F839V',
    status: 'active',
  },
  {
    name: 'Sara',
    surname: 'Romano',
    email: 'sara.romano@email.it',
    fiscal_code: 'RMNSRA88F46A944U',
    status: 'pending',
  },
  {
    name: 'Francesco',
    surname: 'Colombo',
    email: 'f.colombo@gmail.com',
    fiscal_code: 'CLMFNC91G07B354T',
    status: 'active',
  },
  { name: 'Elena', surname: 'Ricci', email: 'elena.ricci@email.it', fiscal_code: 'RCCLNE87H48C351S', status: 'active' },
];

export const MOCK_PREVIEW_DATA = {
  rows: MOCK_USERS,
  total: 342,
};

// Empty condition template
export const EMPTY_CONDITION = { field: '', operator: '', value: '', value2: '', or_group: 0, and_group: 0 };
